import GenericForm from 'components/GenericForm';
import type { GenericFormFields, SitecoreBlockProps } from 'models/sitecore';

interface Props extends SitecoreBlockProps {
	fields?: GenericFormFields;
}

export default function ContactForm({ fields }: Props) {
	if (!fields) {
		return null;
	}

	return (
		<GenericForm
			formLocation="ContactForm"
			sections={fields.sections}
			errorView={fields.error}
			successView={fields.success}
			loadingView={fields.loading}
		/>
	);
}
ContactForm.displayName = 'ContactForm_Partial';
